import React from "react";
import { useNavigate } from "react-router-dom"; // For navigation all that data not founded 

import AutomobilityTabs from './AutomobilityTabs';
import AerospaceIntroductioncards from './AerospaceIntroductioncards';
import AerospaceanimatedCards from './AerospaceanimatedCards';
import Carrerssection from './Carrerssection';
import ValueFirstDatasection from './ValueFirstDatasection';



const Engineeringsectionspage = () => {
  const navigate = useNavigate(); // React Router navigation "react-router-dom",'./AutomobilityTabs.js,', GalleryPage.js, GlobalOffices.js, GroupCompines

  const redirectToPage = (path) => {
    navigate(path);
  };

  return (
    <div>
      {/* Internal CSS */}
      <style>
        {`
         

          .navigation {
            top: 0;
            width: 100%;
            display: flex;
            justify-content: center;
            background-color: #fff;
            padding: 20px 0;
            z-index: 1000;
          }

          .navigation button {
  margin: 0 1px;
  padding: 15px 30px;
  font-size: 18px;
  background-color: #fff;
  color: #11a1b0;
  border: 2px solid #11a1b0; /* Added a 2px black border */
  border-radius: 50px;
  cursor: pointer;
  width: 440px;
  text-align: center;
  transition: background-color 0.3s ease;
}


          .navigation button:hover {
            background-color: #caf6fb;
          }

          .section {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }
        `}
      </style>

      {/* Navigation Buttons */}
      <div className="navigation">
        <button onClick={() => redirectToPage('/mechanicalengineering')}>Mechanical Engineering</button>
        <button onClick={() => redirectToPage('/itengineeringpage')}>Information Technology</button>
        {/* <button onClick={() => redirectToPage('/linedesignpage')}>Electrical Engineering</button> */}
        {/* <button onClick={() => redirectToPage('/teamcenterpage')}>Manufacturing Engineering</button> */}
      </div>


    </div>
  );
};

export default Engineeringsectionspage;
